import Vue from 'vue'
import qs from 'qs'

// Lib imports
import axios from 'axios'
import store from '../store'

import {API_URL, DEBUG} from '../config.env';

const token = store.state.auth.token;

Vue.prototype.$http = axios.create({
	baseURL: API_URL,
	headers: {
		common: {
			Authorization: 'Bearer ' + token,
		},
	},
	proxy: {
		protocol: 'http',
		host: 'localhost',
		port: 80,
	},
});

if (DEBUG) {
	Vue.prototype.$http.interceptors.request.use(config => {
		if (!config.params) {
			config.params = {};
		}
		Object.assign(config.params, {
			'XDEBUG_SESSION_START': 1,
		});
		return config;
	})
}

Vue.prototype.$http.interceptors.response.use(response => response, error => {
	if (error.response && error.response.status === 401) {
		console.debug(
			`%c Unauthorized Http error %c`,
			'background:#1a1abc ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
			'background:transparent',
		);
		location.reload();
	}

	throw error;
})

Vue.prototype.$http.defaults.paramsSerializer = (params) => {
	return qs.stringify(params, {encode: false, skipNulls: true, strictNullHandling: true});
};
